import { render, staticRenderFns } from "./Djjg.vue?vue&type=template&id=4d91dad3&scoped=true"
import script from "./Djjg.vue?vue&type=script&lang=js"
export * from "./Djjg.vue?vue&type=script&lang=js"
import style0 from "./Djjg.vue?vue&type=style&index=0&id=4d91dad3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91dad3",
  null
  
)

export default component.exports